/** The Report Jobs page (web-portal#121). */
export const REPORT_JOBS_PATH = '/reports/jobs'
